import { message } from "antd";
import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  leaveTask,
  setDraftDialogPlay,
} from "store/bailiff/task/dialog/draft_dialog.action";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
export const useDialogLeave = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------
  const handleLeave = (
    info = "Số điểm mà bạn đã chỉnh sửa trong nhiệm vụ này sẽ không được tính",
  ) => {
    setLoading(true);
    dispatch(setDraftDialogPlay(false));
    dispatch(
      leaveTask((res) => {
        setLoading(false);
        if (res?.status === 200) {
          message.info(info);
        }
        if (res?.status === 500) {
          message.error(res?.data);
        }
      }),
    );
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { loading, handleLeave };
};
